/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Polygon } from 'react-native-svg';

import { IconProps } from '../lib';

function YoutubeLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M226.58887,71.81348A15.91692,15.91692,0,0,0,216.95605,60.919C183.479,48.0542,128,48.40747,128,48.40747S72.52148,48.0542,39.044,60.919a15.91766,15.91766,0,0,0-9.63282,10.89428C27.07422,80.78613,24,98.24438,24,128c0,29.75537,3.07422,47.21387,5.41113,56.18652A15.91692,15.91692,0,0,0,39.044,195.08105C72.521,207.9458,128,207.59253,128,207.59253s55.47852.35327,88.95605-12.51148a15.91655,15.91655,0,0,0,9.63282-10.89428C228.92578,175.21387,232,157.75562,232,128,232,98.24463,228.92578,80.78613,226.58887,71.81348ZM112,160V96l48,32Z"
        opacity={0.2}
      />
      <Polygon
        points="160 128 112 96 112 160 160 128"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M24,128c0,29.75546,3.07414,47.21382,5.41108,56.18664a15.91682,15.91682,0,0,0,9.63282,10.89441C72.52083,207.94575,128,207.5925,128,207.5925s55.47857.35324,88.9558-12.51137a15.91684,15.91684,0,0,0,9.6329-10.89432C228.92572,175.214,232,157.75554,232,128s-3.07415-47.21382-5.41108-56.18664A15.91682,15.91682,0,0,0,216.9561,60.919C183.47917,48.05425,128,48.4075,128,48.4075s-55.47857-.35324-88.9558,12.51137a15.91684,15.91684,0,0,0-9.6329,10.89432C27.07427,80.786,24,98.24446,24,128Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default YoutubeLogo;
